import { render, staticRenderFns } from "./WorkspaceExplanationBubble.vue?vue&type=template&id=3435d383&scoped=true"
import script from "./WorkspaceExplanationBubble.vue?vue&type=script&lang=js"
export * from "./WorkspaceExplanationBubble.vue?vue&type=script&lang=js"
import style0 from "./WorkspaceExplanationBubble.vue?vue&type=style&index=0&id=3435d383&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3435d383",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/CFDE Knowledge - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3435d383')) {
      api.createRecord('3435d383', component.options)
    } else {
      api.reload('3435d383', component.options)
    }
    module.hot.accept("./WorkspaceExplanationBubble.vue?vue&type=template&id=3435d383&scoped=true", function () {
      api.rerender('3435d383', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/revealKgWorkspace/WorkspaceExplanationBubble.vue"
export default component.exports